import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '@app/core/services/utilities.service';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
  constructor(private us: UtilitiesService) {}

  transform(value: string | number | Date, format = 'dd MMM yyyy'): string {
    return this.us.formatDate(value, format);
  }
}
